import { Box } from '@material-ui/core';
import React from 'react';
import { IndicatorRect, IndicatorTitle } from './HeatMapLegendStyle';

const HeatMapLegend = ({
  color,
  title
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px"
  }, /*#__PURE__*/React.createElement(IndicatorRect, {
    style: {
      background: color
    }
  }), /*#__PURE__*/React.createElement(IndicatorTitle, null, title, " "));
};

export default HeatMapLegend;